<template>
	<div class="login">
	    <div class="login_1">
            <div class="login_1_1">
                <img :src="require('../assets/login/logo.png')" />
            </div>
            <div class="login_1_2">
                <div class="login_wrap">
                    <div class="login_title">修改密码</div>
                    <div class="login_body">
                        <van-field
                        v-model="loginForm.account" 
                        type="tel" 
                        placeholder="请输入账号" 
                        :left-icon="require('../assets/login/user.png')" 
                        :border="false"
                        />
                        <van-field 
                        v-model="loginForm.oldpassword" 
                        type="password" 
                        placeholder="请输入旧密码" 
                        :left-icon="require('../assets/login/pass.png')" 
                        :border="false"
                        />
                        <van-field 
                        v-model="loginForm.newpassword" 
                        type="password" 
                        placeholder="请输入新密码" 
                        :left-icon="require('../assets/login/pass.png')" 
                        :border="false"
                        />
                        <van-field
                        v-model="loginForm.newpassword2" 
                        type="password" 
                        placeholder="请确认新密码" 
                        :left-icon="require('../assets/login/pass.png')" 
                        :border="false"
                        />
                        <van-button type="primary"
                        color="linear-gradient(180deg, #4482FF 0%, #226AFF 100%)"
                         @click="sbmit()">确认修改</van-button>
                         <router-link to="login">返回登录</router-link>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
	import wx from 'weixin-js-sdk';
    const Base64 = require('js-base64').Base64
	import {Image,popup,field,Imag,button,CountDown,Toast,Checkbox,icon} from "vant";
	import Qs from 'qs';
	export default {
		components: {
			[popup.name]: popup,
			[field.name]: field,
			[Image.name]:Image,
			[button.name]:button,
			[CountDown.name]:CountDown,
			[Toast.name]:Toast,
            [Checkbox.name]:Checkbox,
            [icon.name]:icon
		},
	  data() {
			return {
                loginForm:{
                    account:'',
                    oldpassword:'',
                    newpassword:'',
                    newpassword2:'',
                }
			}
		},
		
		created(){
            
		},
		methods: {
            onchange(value){
                console.log(value)
            },
            sbmit(){
                if(this.loginForm.account===''){
                    this.$message({
                          message: '请填写账号',
                          type: 'warning'
                    });
                	// Toast('');
                	return false;
                }
                if(this.loginForm.oldpassword===''){
                    this.$message({
                          message: '请填写旧密码',
                          type: 'warning'
                    });
                	// Toast('');
                	return false;
                }
                if(this.loginForm.newpassword===''){
                    this.$message({
                          message: '请填写新密码',
                          type: 'warning'
                    });
                	return false;
                }
                if(this.loginForm.newpassword2===''){
                    this.$message({
                          message: '请确认新密码',
                          type: 'warning'
                    });
                	return false;
                }
            	this.axios.post(this.ajaxUrl("wuliu","d=wxapi&c=mp_auth&m=login"), Qs.stringify({
            		"mobile":this.loginForm.account,
                    "password":this.loginForm.oldpassword,
            	})).then((res) => {
            		if (res.data.success) {
            			let list=res.data.data;
                        this.setpassword();
            		}else{
                        this.$message({
                              message: '请输入正确的用户名和密码！',
                              type: 'warning'
                        });
            		}
            	})
            },
			setpassword(){
                
				this.axios.post(this.ajaxUrl("wuliu","d=wxapi&c=user&m=password_save"), Qs.stringify({
					"oldpassword":this.loginForm.oldpassword,
                    "newpassword":this.loginForm.newpassword,
                    "newpassword2":this.loginForm.newpassword2,
				})).then((res) => {
					if (res.data.success) {
                        this.$router.replace('login')
					}else{
						this.$message({
						      message: res.data.message,
						      type: 'warning'
						});
					}
				})
			},
		},
        watch: {
        }
	}
</script>
<style scoped lang="less">
@import '../style/css/variable.less';

        .login{
            height: 100%;
            overflow: hidden;
            position:fixed;
            top:0;
            left:0;
            width: 100%;
            background: url('../assets/login/bg.png') no-repeat center;
            .flex-center();
            flex-flow: column;
            ::v-deep{
                .login_1{
                    .flex-center();
                    width:100%;
                    .login_1_1{
                        width:24.3%;
                        margin-right: 280px;
                    }
                    .login_1_2{
                        position: relative;
                        width: 32.3%;
                        display: flex;
                        .flex-center();
                        flex-flow: column;
                        padding: 30px;
                        box-sizing: border-box;
                        .login_wrap{
                            width:100%;
                            height: 100%;
                            background: #070C43;
                            position: relative;
                            &::after{position: absolute;left:-30px;bottom:-30px;background: url('../assets/login/4.png') no-repeat center;background-size: 58px 58px;content: '';width: 58px;height: 58px;}
                            &::before{position: absolute;right:-30px;bottom:-30px;background: url('../assets/login/3.png') no-repeat center;background-size: 58px 58px;content: '';width: 58px;height: 58px;}
                        }
                        .login_title{
                            font-size: 30px;color: @white;padding:50px 0 40px 0;text-align: center;
                        }
                        .login_body{
                            padding: 0 40px;
                            .van-field{
                                height: 60px;background: #02004C;border: 1px solid #86A9D6;margin-bottom: 30px;
                                .van-field__left-icon{
                                    .flex-center();
                                    margin-right: 20px;
                                    .van-icon{
                                        .flex-center();
                                    }
                                }
                                input{
                                    color: @white;
                                    background: transparent;
                                    &.van-field__control::placeholder{
                                        color: @white;
                                    }
                                }
                            }
                            .van-cell{
                                line-height: 40px;
                            }
                            a{
                                color: @white;font-size: 18px;text-align: center;margin:20px 0 40px 0;display: block;
                            }
                        }
                        &::after{position: absolute;left:0;top:0;background: url('../assets/login/1.png') no-repeat center;background-size: 58px 58px;content: '';width: 58px;height: 58px;}
                        &::before{position: absolute;right:0;top:0;background: url('../assets/login/2.png') no-repeat center;background-size: 58px 58px;content: '';width: 58px;height: 58px;}
                    }
                }
                .van-button{
                    width: 100%;
                	height:60px;
                	line-height: 60px;
                	font-size:20px;
                    
                }
                // .van-checkbox{
                //     margin-right: 0.1rem;
                //     .van-checkbox__icon{
                //         .flex-start();
                //         .van-icon{
                //             width: 0.3rem;
                //             height: 0.3rem;
                //             line-height: 0.3rem;
                //             font-size: 0.3rem;
                //             border: 0.02rem solid #c8c9cc;
                //             &.van-icon-success::before{
                //                 width: 0.3rem;
                //                 height: 0.3rem;
                //                 font-size: 0.3rem;
                //                 line-height: 0.3rem;
                //                 margin:0;
                //             }
                //             &.van-icon-success{
                //                 border: 0.02rem solid @main;
                //             }
                //         }
                //     }
                    
                // }
            }
        }
    
    
</style>